import { useState, useCallback } from 'react';

const STORAGE_KEY = 'vedic_chart_style';

export default function useChartPreference() {
  const [style, setStyleState] = useState(() => {
    return localStorage.getItem(STORAGE_KEY) || 'south';
  });

  const setStyle = useCallback((s) => {
    setStyleState(s);
    localStorage.setItem(STORAGE_KEY, s);
  }, []);

  const toggle = useCallback(() => {
    setStyle(style === 'south' ? 'north' : 'south');
  }, [style, setStyle]);

  return { style, setStyle, toggle };
}
